import { jwtDecode } from 'jwt-decode';
/**
 * Converts a numeric date to a date in milliseconds.
 *
 * The JWT standard defines that dates are represented as the number of seconds
 * since the Unix epoch (1970-01-01T00:00:00Z).
 *
 * This function converts the number of seconds to milliseconds.
 *
 * @see https://www.rfc-editor.org/rfc/rfc7519#section-2
 */
export const fromNumericDate = (seconds) => seconds * 1000;
/**
 * Check if a JWT token is expired.
 *
 * @param token Valid JWT token
 * @param gracePeriod Additional time to consider the token as expired
 * @returns `true` if the token is expired
 */
export function isTokenExpired(token, gracePeriod = 0) {
    if (!token) {
        return true;
    }
    try {
        const { exp } = jwtDecode(token);
        if (!exp) {
            return false;
        }
        const remainingLife = fromNumericDate(exp) + gracePeriod - Date.now();
        return remainingLife <= 0;
    }
    catch (error) {
        return true;
    }
}
export function getTokenAud(token) {
    if (!token) {
        return;
    }
    try {
        const { aud } = jwtDecode(token);
        if (typeof aud === 'string') {
            return aud;
        }
        if (Array.isArray(aud)) {
            return aud[0];
        }
    }
    catch { }
}
//# sourceMappingURL=token.js.map